import React, { Fragment, useEffect, useState } from 'react'
import { Breadcrumb, Card, Col, Container, CardBody, Button, CardHeader, Row } from 'reactstrap'
import AddDeliverySlotModal from './AddDeliverySlotModal';
import DataTable from "react-data-table-component";
import customAxios from '../../../customAxios';
import { toast } from "react-toastify";
const DeliverySlot = () => {
    const [datas, setDatas] = useState([])
    const [open, setOpen] = useState(false);


    const getList = async () => {
        try {
            const response = await customAxios.get('admin/list-deliveryslots')
            setDatas(response?.data?.data)
        } catch (err) {
            toast.error(err?.message);
        } 
    }


    useEffect(() => {
        getList()
    }, [])




    const onOpenModal = () => {
        setOpen(true);
    };

    // const onCloseModal = () => {
    //     setOpen(false);
    // };

    const Capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };


    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you wish to delete this item?")) {
            try {
                await customAxios.delete(`admin/delete-deliveryslots/${id}`)
                const deletes = datas?.filter((res) => res?._id !== id);

                setDatas(deletes)
                toast.success(`Deleted Successfully`);

            } catch (err) {

            } finally {

            }
        }


    }
    var columns = [
        {
            name: <b>{Capitalize("S.No")}</b>,
            header: <b>{Capitalize("S.No")}</b>,
            cell: (row, index) => index + 1
        },

        {
            name: <b>{Capitalize("Day")}</b>,
            header: <b>{Capitalize("Category Name")}</b>,
            selector: row => row?.day,
            style: {
                textAlign: "center",
            },
        },

        {
            name: <b>{Capitalize("From Date")}</b>,
            header: <b>{Capitalize("From Date")}</b>,
            selector: row => row?.fromTime,
            style: {
                textAlign: "center",
            },
        },
        {
            name: <b>{Capitalize("To Date")}</b>,
            header: <b>{Capitalize("To Date")}</b>,
            selector: row => row?.toTime,
            style: {
                textAlign: "center",
            },
        },
        {
            name: <b>Actions</b>,
            id: "delete",
            accessor: (str) => "delete",
            cell: (row, index) => (

                <>
                    <span onClick={() => handleDelete(row._id)} >

                        <i
                            className="fa fa-trash"
                            style={{
                                width: 35,
                                fontSize: 20,
                                padding: 11,
                                color: "#e4566e",
                                cursor: "pointer"
                            }}
                        ></i>
                    </span>

                </>
            )
        }
    ];


    return (
        <Fragment>
            <Breadcrumb title="Delivery Slot" parent="Settings" />
            {/* <!-- Container-fluid starts--> */}
            <Container fluid="true">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <h5>Delivery Slot</h5>
                            </CardHeader>
                            <CardBody>
                                <div className="btn-popup pull-right">
                                    <Button
                                        type="button"
                                        color="secondary"
                                        onClick={onOpenModal}
                                        data-toggle="modal"
                                        data-original-title="test"
                                        data-target="#exampleModal"

                                    >
                                        Add Delivery Slot

                                    </Button>

                                </div>
                                <div className="clearfix"></div>
                                <div id="basicScenario" className="product-physical">
                                    <DataTable
                                        pagination
                                        columns={columns}
                                        data={datas}
                                        fixedHeader
                                        subHeader
                                    // subHeaderComponent={subHeaderComponentMemo}  
                                    />

                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            {open && <AddDeliverySlotModal
            getList={getList}
                openModal={open}
                onCloseModal={() => {

                    setOpen(false)
                }}


                title={'Add Time Slot'}
            /> }


        </Fragment>
    )
}

export default DeliverySlot